import { type AppStateStatus } from 'react-native';

type AppStateProps = {
	current: AppStateStatus;
	next: AppStateStatus;
};

const backgroundStatuses: AppStateStatus[] = ['inactive', 'background'];
const foregroundStatuses: AppStateStatus[] = ['active'];

class AppStateHelper {
	static isForegrounded({ current, next }: AppStateProps): boolean {
		return backgroundStatuses.includes(current) && foregroundStatuses.includes(next);
	}

	static isBackgrounded({ current, next }: AppStateProps): boolean {
		return foregroundStatuses.includes(current) && backgroundStatuses.includes(next);
	}
}

export default AppStateHelper;
